import { Navigate } from 'react-router-dom';
import { auth } from '../utils/auth';

const PrivateRoute = ({ children, requireDistributor, requireBusiness }) => {
  if (!auth.isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  if (requireDistributor && !auth.isDistributor() && !auth.getUserType() === 'subUser') {
    return <Navigate to="/" />;
  }

  if (requireBusiness && !auth.isBusiness()) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute; 